import React from 'react';
import { Redirect } from 'react-router-dom';

import { RouterError } from '~src/bootstrap/routerHelpers/RouterError';
import { Favorites } from '~src/favorites/resources/Favorites';
import { IPublishedConnectionTableDetailInfo } from '~src/publishedConnectionTable/models/IPublishedConnectionTableInfo';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';

import { PublishedConnectionTables } from '../resources/PublishedConnectionTables';

export interface PublishedConnectionTableSpaceFavoriteRedirectProps {
  readonly publishedConnectionTableId: string;
  readonly urls: SpacesSiteUrls;
}

type PublishedConnectionTableStatus = 'unfetched' | 'fetched' | 'error';

export const PublishedConnectionTableSpaceFavoriteRedirect: React.FunctionComponent<PublishedConnectionTableSpaceFavoriteRedirectProps> = props => {
  const [ publishedConnectionTableStatus, setPublishedConnectionTableStatus ] = React.useState<PublishedConnectionTableStatus>('unfetched');

  React.useEffect(
    () => {
      let didCancel = false;

      fetchPublishedConnectionTable(props.publishedConnectionTableId)
        .then(() => !didCancel && setPublishedConnectionTableStatus('fetched'))
        .catch(() => {
          removeFavoritePublishedConnectionTable(props.publishedConnectionTableId);
          !didCancel && setPublishedConnectionTableStatus('error');
        });

      return () => didCancel = true;
    },
    [props.publishedConnectionTableId]
  );

  if (publishedConnectionTableStatus === 'unfetched') {
    return null;
  } else if (publishedConnectionTableStatus === 'fetched') {
    return <Redirect to={props.urls.virtualConnectionTablePath(props.publishedConnectionTableId)}/>;
  } else {
    return <RouterError errorType={'virtualConnectionTable-removed-favorite'} urls={props.urls} />;
  }
};

async function fetchPublishedConnectionTable(publishedConnectionTableId: string): Promise<IPublishedConnectionTableDetailInfo> {
  return PublishedConnectionTables.getById(publishedConnectionTableId);
}

function removeFavoritePublishedConnectionTable(publishedConnectionTableId: string) {
  Favorites.remove(publishedConnectionTableId, 'virtualConnectionTable');
}
